import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { App, Divider, Form, Input, Radio } from "antd";
import { useCallback, useEffect, useState } from "react";
import { copyToClipboard } from "@devowl-wp/react-utils";
import { __, _x } from "../../../../utils/i18n.js";
const LAYOUT = {
    labelCol: {
        span: 24
    },
    wrapperCol: {
        span: 24
    }
};
/**
 * A generic generator for three types of shortcode links. For more details see `LinkShortcode.php`.
 */ const LinkShortcodeForm = ({ type })=>{
    const { message } = App.useApp();
    const [result, setResult] = useState("");
    const initialValues = {
        tag: "a",
        id: "",
        text: type === "history" ? _x("Privacy settings history", "legal-text") : type === "revoke" ? _x("Revoke consents", "legal-text") : _x("Change privacy settings", "legal-text"),
        successmessage: type === "revoke" ? _x("You have successfully revoked consent for services with its cookies and personal data processing. The page will be reloaded now!", "legal-text") : ""
    };
    const [form] = Form.useForm();
    // Generate the shortcode and hold the result in state
    const handleValuesChange = useCallback((changedValues, values)=>{
        const attr = [];
        for (const key of Object.keys(values)){
            const value = values[key];
            if (value) {
                attr.push(`${key}="${value.replace('"', '\\"')}"`);
            }
        }
        setResult(`[rcb-consent type="${type}" ${attr.join(" ")}]`);
    }, [
        setResult
    ]);
    // Generate once
    useEffect(()=>{
        handleValuesChange(initialValues, initialValues);
    }, []);
    // Copy the shortcode to clipboard
    const handleCopyTextarea = useCallback(()=>{
        copyToClipboard(result);
        message.success(__("Successfully copied shortcode to clipboard!"));
    }, [
        result
    ]);
    return /*#__PURE__*/ _jsxs(Form, {
        name: `link-shortcode-${type}`,
        form: form,
        ...LAYOUT,
        initialValues: initialValues,
        onValuesChange: handleValuesChange,
        children: [
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Appearance"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "tag",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                            children: [
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "a",
                                    children: __("Link")
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: "button",
                                    children: __("Button")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("It is recommended to use a simple link in your footer instead of a button to avoid visual misunderstandings.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("HTML ID"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "id",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Input, {})
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("If you want to apply a custom style to the link/button, the shortcode output should be tagged with an ID attribute.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Text"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "text",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Input, {})
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("The user must be able to clearly understand the behaviour of the link/button from the name.")
                    })
                ]
            }),
            type === "revoke" && /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Success message"),
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "successmessage",
                        noStyle: true,
                        children: /*#__PURE__*/ _jsx(Input.TextArea, {
                            autoSize: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("After the consent is revoked, the page will be reloaded. Let the user know what happened with a success message.")
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Form.Item, {
                children: [
                    /*#__PURE__*/ _jsxs(Form.Item, {
                        noStyle: true,
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {
                                style: {
                                    marginTop: 0
                                },
                                children: __("Result")
                            }),
                            /*#__PURE__*/ _jsx(Input.TextArea, {
                                value: result,
                                readOnly: true,
                                autoSize: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("Copy the generated shortcode and paste it into your website.")
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "button alignright",
                        onClick: handleCopyTextarea,
                        children: __("Copy to clipboard")
                    })
                ]
            })
        ]
    });
};
export { LinkShortcodeForm };
